import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestService } from '@app/core/api/rest.service';
import { HttpCancelInterceptor } from '@app/core/interceptor/http.cancel.interceptor';
import { Benutzer, PayloadBenutzerStatus, PayloadBoolean, PayloadKontaktList, PayloadUserSetting, UserSetting } from '@pezi/entities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RestUserService extends RestService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  async logoutUser(): Promise<boolean> {

    try {
      await this.http.get(this.baseUrl + '/logout', this.httpOptions).toPromise();
    } catch (e) {
      return false;
    }
    return true;

  }

  getLoggedInUser(): Observable<Benutzer> {
    return this.http
      .get<Benutzer>(this.baseUrl + '/me', this.httpOptions);
  }

  getUserSettings(): Observable<PayloadUserSetting> {

    const disableCancelInterceptor = Object.assign({}, this.httpOptions, {headers: this.httpOptions.headers.append( HttpCancelInterceptor.DISABLE_CANCEL_INTERCEPTOR, 'true' )});

    return this.http
      .get<PayloadUserSetting>(this.baseUrl + '/user-settings', disableCancelInterceptor);
  }

 saveUserSettings(userSetting: UserSetting): Observable<PayloadBoolean> {
    return this.http
      .post<PayloadBoolean>(
        this.baseUrl + '/user-settings/',
        userSetting,
        this.httpOptions);
  }

  getUserKontakte(): Observable<PayloadKontaktList> {
    return this.http
      .get<PayloadKontaktList>(this.baseUrl + '/kontakte', this.httpOptions);
  }

  requestToken(email: string): Observable<PayloadBoolean>{
    return this.http
      .post<PayloadBoolean>(
        this.baseUrl + '/auth/login/token/issue',
        {email},
        this.httpOptions);
  }

  loginWithToken(token: string): Observable<PayloadBoolean>{
    return this.http
      .post<PayloadBoolean>(
        this.baseUrl + '/auth/login/token',
        {token},
        this.httpOptions);
  }

  loginExternal(username: string, pwd: string): Observable<PayloadBoolean> {
    const body = {
      email:    username,
      password: pwd
    } as UserPasswordDto;

    return this.http
      .post<PayloadBoolean>(
        this.baseUrl + '/auth/login',
        body,
        this.httpOptions);
  }

  rememberMe(): Observable<PayloadBoolean> {
    return this.http.post<PayloadBoolean>(this.baseUrl + '/auth/rememberme', {}, this.httpOptions);
  }

  checkRememberMe(): Observable<PayloadBoolean> {
    return this.http.get<PayloadBoolean>(this.baseUrl + '/auth/rememberme/check',this.httpOptions);
  }

  removeRememberMe(): Observable<PayloadBoolean> {
    return this.http.post<PayloadBoolean>(this.baseUrl + '/auth/rememberme/remove', {}, this.httpOptions);
  }

  getStatusForUser(userId: string): Observable<PayloadBenutzerStatus> {
    return this.http
      .get<PayloadBenutzerStatus>(this.baseUrl + '/benutzerstatus/' + userId +'/status', this.httpOptions);
  }

  refreshUser(): Observable<Benutzer> {
    return this.http
      .get<Benutzer>(this.baseUrl + '/refreshme', this.httpOptions);
  }

  acceptAgb(): Observable<PayloadBoolean> {
    return this.http.put<PayloadBoolean>(this.baseUrl + '/acceptagb', {}, this.httpOptions);
  }
}

export interface UserPasswordDto {
  email: string;
  password: string;
}

